const GraphQLForm = require('app/graphql/Form');
const ConfirmModal = require('app/ui/modal/Confirm');
const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const GraphQLMutation = require('app/graphql/Mutation');

class Form extends GraphQLForm {

    defaultOptions(){
        var options = {
            'mutationType': 'SubmitSeller',
            'seller': {
                'id': '',
                'email': '',
                'firstName': '',
                'lastName': '',
                'phone': '',
				'marginDisabled': false,
            },
        };
        return Object.assign(super.defaultOptions(),options);
    }

    initialize() {
        var self = this;

        this.seller = this.settings.seller;

        this.createMode = true;
        if(this.seller.id){
            this.createMode = false;
        }

        this.$form = $('<form/>')
        .addClass('seller-info-form');

        this.loadData();

        super.initialize();
    }

    getSeller(){
        return this.seller;
    }

    getForm(){
        return this.$form;
    }

    refresh(){
        this.loadData();
    }

    loadData(){
        var self = this;

        this.$form.html('');

        let queries = [
        ];

        if(this.seller.id){
            queries.push(this.buildSellerQuery());
        }

        if(queries.length <= 0){
            return this.fillForm({});
        }

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.fillForm(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildSellerQuery(){
        var self = this;

        let id = this.seller.id;
        let parameters = {
            'id': id,
        };

        let fields = [
            'id',
            'user { firstName lastName email }',
            'phone',
            'type',
            'commission',
            'marginDisabled',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'seller',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }


    fillForm(data){
        if(data.seller){
            this.seller = data.seller;
        }

        this.$btnSubmit = $('<button/>')
        .attr('type','submit')
        .addClass('btn btn-success');

        if(this.seller.id){
            this.$btnSubmit.append('Modifier ce commercial');
        }else{
            this.$btnSubmit.append('Ajouter ce commercial');
        }

        this.$form
        .append(
            $('<div/>')
            .append(this.buildForm())
            .append(
                $('<div/>')
                .addClass('d-flex justify-content-center')
                .append(this.$btnSubmit)
            )
        );

        return this.$form;
    }

    getFields(){
        let fields = super.getFields();
        fields.push('seller { id }');
        return fields;
    }
    
    getVariables(){
        let variables = {};

        if(this.seller.id){
            variables.seller = {
                'value': this.seller.id,
                'type': 'Int'
            }
        }

        return variables;
    }

    buildForm(){
        var self = this;

        let $box = $('<div/>')
        .addClass('white-box');

        //LABEL
        let $label = $('<h3/>')
        .addClass('box-title')
        .append(window.translate('app.supplier.show.tabs.info.infoForm.label'))
        .appendTo($box);

		if(this.seller.user){
			var firstName = this.seller.user.firstName;
			var lastName = this.seller.user.lastName;
			var email = this.seller.user.email;
		}else{
			var firstName = '';
			var lastName = '';
			var email = '';
		}
        let phone = this.seller.phone;
        let type = this.seller.type;
        let commission = this.seller.commission;
        let marginDisabled = this.seller.marginDisabled;

        //FIELD email
        let $emailLabel = $('<label/>')
        .attr('for','phone')
        .append('Adresse email');
        let $emailInput = $('<input/>')
        .attr('type','email')
        .attr('name','email')
        .attr('autocomplete','off')
        .addClass('form-control')
        .val(email);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($emailLabel)
            .append($emailInput)
        )

        //FIELD phone
        let $phoneLabel = $('<label/>')
        .attr('for','phone')
        .append(window.translate('app.supplier.show.tabs.info.infoForm.phone.label'));
        let $phoneInput = $('<input/>')
        .attr('type','text')
        .attr('name','phone')
        .addClass('form-control')
        .val(phone);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($phoneLabel)
            .append($phoneInput)
        )

        //FIELD lastName
        let $lastNameLabel = $('<label/>')
        .attr('for','lastName')
        .append('Nom');
        this.$inputlastName = $('<input/>')
        .attr('type','text')
        .attr('name','lastName')
        .addClass('form-control')
        .val(lastName);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($lastNameLabel)
            .append(this.$inputlastName)
        )

        //FIELD firstName
        let $firstNameLabel = $('<label/>')
        .attr('for','firstName')
        .append('Prénom');
        this.$inputfirstName = $('<input/>')
        .attr('type','text')
        .attr('name','firstName')
        .addClass('form-control')
        .val(firstName);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($firstNameLabel)
            .append(this.$inputfirstName)
        )

        //FIELD password
        let $passwordLabel = $('<label/>')
        .attr('for','password')
        .append('Mot de passe');
        this.$inputPassword = $('<input/>')
        .attr('type','password')
        .attr('name','password')
        .attr('autocomplete','new-password')
        .addClass('form-control');
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($passwordLabel)
            .append(this.$inputPassword)
        )

        //FIELD password confirmation
        let $confirmationLabel = $('<label/>')
        .attr('for','passwordConfirm')
        .append('Confirmation');
        this.$inputConfirmation = $('<input/>')
        .attr('type','password')
        .attr('name','passwordConfirm')
        .attr('autocomplete','new-password')
        .addClass('form-control');
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($confirmationLabel)
            .append(this.$inputConfirmation)
        )

        //FIELD commission
        let $commissionLabel = $('<label/>')
        .attr('for','commission')
        .append('Commission (%)');
        let $commissionInput = $('<input/>')
        .attr('type','text')
        .attr('name','commission')
        .addClass('form-control')
        .val(commission);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($commissionLabel)
            .append($commissionInput)
        )

        //FIELD type
        let $typeLabel = $('<label/>')
        .attr('for','type')
        .append('Type de commercial ');
        let $typeInput = $('<select/>')
        .attr('name','type')
        .addClass('form-control');
		$typeInput.append(
			$('<option/>')
			.val('commercial')
			.text('Commercial Restofuté')
		);
		$typeInput.append(
			$('<option/>')
			.val('agentco')
			.text('Agent commercial')
		);
		$typeInput.append(
			$('<option/>')
			.val('franchise')
			.text('Franchise')
		);
		$typeInput.val(type);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($typeLabel)
            .append($typeInput)
        )

        //FIELD marginDisabled
        let $marginDisabledLabel = $('<label/>')
        .attr('for','marginDisabled')
        .append(' Aucune marge');
        let $marginDisabledInput = $('<input/>')
        .attr('type','checkbox')
        .attr('name','marginDisabled')
        .val('1');
		
		if(marginDisabled == true)
			$marginDisabledInput.attr('checked','checked');

		$marginDisabledLabel.prepend($marginDisabledInput);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($marginDisabledLabel)
        )

        return $box;
    }
}

module.exports = Form;

